import { createBrowserClient } from "@supabase/ssr";

// Defensive URL normalization — Supabase rejects trailing slash or stale
// /rest/v1 path suffix with PGRST125 ("Invalid path specified").
const SUPABASE_URL = (process.env.NEXT_PUBLIC_SUPABASE_URL ?? "")
  .replace(/\/rest\/v1\/?$/, "")
  .replace(/\/+$/, "");

export function createClient() {
  return createBrowserClient(
    SUPABASE_URL,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  );
}
